export default __webpack_public_path__ + "static/media/group6.d3251895.png";